module.exports = "<template> <div class=col-xs-12 style=background-color:#fff;padding:10px> <slot></slot> </div> </template> ";